<template>
  <div>
    <b-modal id="modal-lots"
             size="lg"
             @show="getLot(process_id)"
             title="Lotes procesados">
      <b-table striped small hover :items="items" :fields="fields"></b-table>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: "LotModal",
    props: {
      process_id : {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        loading: false,
        items: [{
          number: null,
          processed_count: null,
          variety: null,
          origin: null,
          waybill: null,
          product_name: null,
        }],
        fields: [
          {
            key: 'number',
            label: 'Número'
          },
          {
            key: 'product_name',
            label: 'Especie',
          },
          {
            key: 'variety',
            label: 'Variedad',
          },
          {
            key: 'waybill',
            label: 'Guía',
          },
          {
            key: 'origin',
            label: 'Huerto',
          },
          {
            key: 'processed_count',
            label: 'Procesados',
            class: 'text-center'
          },
        ],
      }
    },
    methods: {
      async getLot(evt) {
        const thisV = this;
        let url = '';
        thisV.loading = true;
        url = `api/v1/lot/${evt}/lot_count/`;
        try {
          const response = await thisV.$axios({
            method: "GET",
            url: url,
          });
          thisV.loading = false;
          thisV.items = response.data;
        } catch (error) {
          console.log(error);
          thisV.$toast.error("Problemas al cargar lotes", "");
          thisV.loading = false;
        }
      },
    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>
